import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import EditButton from '../../ui/EditButton';

export default function MembershipReconciliationCard({ teamId, reconciliationEnabled }) {
  const navigate = useNavigate();
  const path = reconciliationEnabled
    ? `/teams/${teamId}/membership-reconciliation`
    : `/teams/${teamId}/club-billing`;
  const title = reconciliationEnabled ? 'Membership Reconciliation' : 'Membership Payments & Billing';

  return <div className="team-card">
    <div className="card-header-with-icon">
      <span className="card-title">{title}</span>
      <EditButton section={title.toLowerCase()} label="Manage" onEdit={() => navigate(path)} />
    </div>
    <div className="card-body">
      {reconciliationEnabled ? <>
        <p>Record externally collected membership payments and keep the treasurer’s records up to date.</p>
        <p className="text-muted small">Create payment rounds, assign members, then mark payments as paid or waived.</p>
      </> : <>
        <p>Choose how membership payments are handled and review the club’s annual Member Nest billing.</p>
        <p className="text-muted small">Treasurer Reconciliation can be enabled as an optional module.</p>
      </>}
      <div className="courses-card__actions">
        <Link className="button button-primary" to={path}>
          {reconciliationEnabled ? 'Manage payments' : 'Open billing'}
        </Link>
      </div>
    </div>
  </div>;
}
